export default __webpack_public_path__ + "static/media/small.4cedb4a0.jpg";